import React, { useState } from 'react';
import { useRoute } from '@react-navigation/native';

import { GET_STOCKTAKE } from '../../../common/graphql/stocktake';
import { ActionDock, Screen } from '../../design/components';

import StocktakeDetail from './StocktakeDetail';

const StocktakeDetailView = () => {
	const route = useRoute();
	const stocktakeId = route.params?.id;
	// The child reports its primary action so it renders in the measured Screen dock.
	const [dockProps, setDockProps] = useState(null);

	return (
		<Screen backLabel="Stocktakes" scroll={false} dock={dockProps ? <ActionDock hint={dockProps.hint} action={dockProps.action} /> : null}>
			<StocktakeDetail
				id={stocktakeId}
				query={GET_STOCKTAKE}
				onDockChange={setDockProps}
			/>
		</Screen>
	);
};

export default StocktakeDetailView;
